import React from 'react'
import { Box } from '@mui/material'
import uniLogo from '@/assets/Logo.png'

type BanhangLogoProps = {
  size?: number
}

/** Logo UNI Viet Nam trên form đăng nhập. */
const BanhangLogo: React.FC<BanhangLogoProps> = ({ size = 56 }) => {
  return (
    <Box
      component="img"
      src={uniLogo}
      alt="UNI Viet Nam"
      sx={{
        height: size,
        width: 'auto',
        maxWidth: size * 2.4,
        objectFit: 'contain',
        flexShrink: 0,
        display: 'block',
        borderRadius: 1,
      }}
    />
  )
}

export default BanhangLogo
